import { useMemo } from 'react';
import { JACKPOT_NAMES, SECTION_NAMES } from '@repo/common';
import { useJackpotsStore } from '../../../../store/jackpotsStoreSimple';

export const usePremiumLinkInfo = () => {
  const jackpotGames = useJackpotsStore((state) => state.jackpotsFromAPI.get(JACKPOT_NAMES.PREMIUM_LINK)?.games);

  return useMemo(() => {
    const games = jackpotGames ?? [];
    const sectionName = SECTION_NAMES.PREMIUM_LINK;

    return { games, sectionName };
  }, [jackpotGames]);
};

/**
 * Non-hook reader for the Premium Link game keys.
 * Reads the store synchronously via getState(), so it can be used inside plain
 * helper functions (e.g. categorizeJackpot) without violating the Rules of Hooks.
 */
export const getPremiumLinkGameKeys = (): string[] => {
  const premiumLinkJackpot = useJackpotsStore.getState().jackpotsFromAPI.get(JACKPOT_NAMES.PREMIUM_LINK);
  return premiumLinkJackpot?.games ?? [];
};
